<template>
  <aside class="Panel PanelAdvice">
    <transition name="fade" appear v-if="data"><div class="Panel_cache" @click="closePanel"></div></transition>
    
    <transition name="fade" appear>
      <button class="Panel_close" @click="closePanel" v-if="data"><i class="fal fa-times"></i></button>
    </transition>

    <transition name="panel" appear>
      <div class="Panel_wrapper" v-if="data" ref="wrapper">
        <div class="Panel_content Panel_intro">
          <h6 v-html="data.suptitle" v-if="data.suptitle"></h6>
          <h3 v-html="data.title" v-if="data.title"></h3>
          <p v-html="data.introduction" v-if="data.introduction"></p>

          <Media :data="data.illustration" v-if="data.illustration" />

          <div class="Slash Slash_grey"></div>
        </div>

        <div class="Panel_content Panel_content_grey">
          <div class="LinkPushs" v-for="(list, index) in data.lists" :key="index">
            <h4 v-if="list.links.length > 0">{{ list.titles }}</h4>
            <LinkPush :data="link" :key="index" v-for="(link, index) in list.links" />
          </div>
        </div>
      </div>
    </transition>
    
  </aside>
</template>

<script>
  import panel from '@/mixins/panel'

  import Media from "@/components/Media"

  export default {
    name: "PanelAdvice",
    mixins: [ panel ],
    components: { Media },
    data() {
      return {
        data: null
      }
    },
    props: [ 'datas' ],
    methods: {
      // fetchData()
      // {
      //   this.$api.getAdvice(this.slug)
      //   .then(response => {
      //     this.data = response.data
      //   })
      // }
    },
    mounted()
    {
      this.data = this.datas
      // this.fetchData()
    }
  }
</script>

<style lang="stylus" scoped>
// .PanelAdvice

  
</style>